import { render } from "./SchemasSelect.vue?vue&type=template&id=33a6341e&scoped=true"
import script from "./SchemasSelect.vue?vue&type=script&lang=js"
export * from "./SchemasSelect.vue?vue&type=script&lang=js"

import "./SchemasSelect.vue?vue&type=style&index=0&id=33a6341e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a6341e"]])

export default __exports__